import { render, staticRenderFns } from "./CanceledReservationDetail.vue?vue&type=template&id=2659d072&scoped=true"
import script from "./CanceledReservationDetail.vue?vue&type=script&lang=js"
export * from "./CanceledReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./CanceledReservationDetail.vue?vue&type=style&index=0&id=2659d072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659d072",
  null
  
)

export default component.exports